import React from 'react'
import { Box, Button, Grid, Typography } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import { routes } from 'Routes'
import helpers from 'helpers'
import useStyles from './styles'

const SSOError = ({ slug }) => {
  const classes = useStyles()
  const history = useHistory()

  const handleBack = () =>
    history.push(
      reverse(routes.root, { slug: helpers.whiteLabel.resolveSlug(slug) }),
    )

  return (
    <Grid container justify="center">
      <Grid item xs={12}>
        <Box className={classes.content}>
          <img
            alt="Erro no login SSO"
            className={classes.image}
            src="/images/forbidden.svg"
          />
          <Box mt={3}>
            <Typography variant="h2" color="primary">
              Falha no login SSO
            </Typography>
          </Box>
          <Box className={classes.subtitle}>
            <Typography variant="subtitle2">
              Ocorreu um erro ao tentar realizar o login. Por favor, tente
              novamente. Caso o problema persista, entre em contato com o
              suporte.
            </Typography>
          </Box>
          <Button
            className={classes.button}
            color="primary"
            variant="contained"
            onClick={handleBack}
          >
            Voltar
          </Button>
        </Box>
      </Grid>
    </Grid>
  )
}

export default SSOError
